import { CSSProperties } from "react"
import { useNavigate } from "react-router-dom"
import { BottomSheet } from "./BottomSheet"
import Icon from "./Icon"
import { MenuItem } from "../menu/DropdownMenu"

interface IProps {
    id: string
    open: boolean
    onClose: () => void
    title?: string
    subtitle?: string
    source: MenuItem[]
}

// iOS-style action sheet that slides up from the bottom, listing a set of actions as
// tappable rows. Built on BottomSheet (mobile-only). Replaces crowded header icon
// toolbars: a single trigger button opens this and flattens every action into a list.
export default function ActionSheet(props: IProps) {

    const navigate = useNavigate()

    const items = props.source.filter(f => f.visible == undefined || f.visible)

    const run = async (item: MenuItem, e: any) => {
        if (item.click) await item.click(e)
        else if (item.action) item.action()
        else if (item.to) navigate(item.to)
        props.onClose()
    }

    return (
        <BottomSheet id={props.id} open={props.open} onClose={props.onClose}>
            <div className="action-sheet">
                {
                    (props.title || props.subtitle) &&
                    <div className="text-center mb-3">
                        {props.title && <div className="fs-4 fw-bolder text-gray-900">{props.title}</div>}
                        {props.subtitle && <div className="fs-8 text-gray-500">{props.subtitle}</div>}
                    </div>
                }

                <div className="action-sheet-group" style={{
                    borderRadius: 14,
                    overflow: "hidden",
                    background: "var(--bs-gray-100)"
                }}>
                    {
                        items.map((item, k) => {
                            const cls = "action-sheet-item d-flex align-items-center px-3 py-3 cursor-pointer " + (item.danger ? "text-danger" : "text-gray-800")
                            const style: CSSProperties = {
                                borderTop: k === 0 ? undefined : "1px solid var(--bs-gray-200)"
                            }
                            const inner = (
                                <>
                                    <span className="symbol symbol-35px me-3">
                                        <span className={"symbol-label " + (item.danger ? "bg-light-danger" : "bg-white")}>
                                            <Icon icon={item.icon} type={item.iconType ?? "solid"} size={15}
                                                color={item.iconColor}
                                                className={item.iconColor ? "" : (item.danger ? "text-danger" : "text-gray-700")} />
                                        </span>
                                    </span>
                                    <div className="flex-grow-1">
                                        <div className="fs-5 fw-bold">{item.title}</div>
                                        {item.subtext && <div className="text-muted fw-normal fs-8">{item.subtext}</div>}
                                    </div>
                                </>
                            )
                            return item.redirect ? (
                                <a key={k} href={item.redirect} target="_blank" rel="noreferrer"
                                    style={style} className={cls} onClick={() => props.onClose()}>
                                    {inner}
                                </a>
                            ) : (
                                <div key={k} style={style} className={cls} onClick={e => run(item, e)}>
                                    {inner}
                                </div>
                            )
                        })
                    }
                </div>

                <button type="button" className="btn btn-light w-100 mt-3 fw-bolder"
                    onClick={() => props.onClose()}>
                    Cancel
                </button>
            </div>
        </BottomSheet>
    )
}
